/*
 * Abba & Co. — global motion.
 * [data-reveal]: rises 8px over 300ms when it enters the viewport, always
 *   fully visible; optional data-reveal-delay (ms) for staggering.
 * [data-parallax="0.2"]: the layer moves at that factor relative to scroll;
 *   its parent clips it and the layer is oversized 10–14% top and bottom.
 * Everything is off under prefers-reduced-motion and in the theme editor.
 */
(function () {
  if (window.AbbaCoMotion) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  var off = reduce || editor;
  var seen = new WeakSet();
  var par = new Set();
  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              e.target.style.transform = 'none';
              io.unobserve(e.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
        )
      : null;

  function scan() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      if (off || !io) return;
      var d = +el.getAttribute('data-reveal-delay') || 0;
      el.style.transform = 'translateY(8px)';
      el.style.transition = 'transform 300ms cubic-bezier(.2,.7,.2,1) ' + d + 'ms';
      io.observe(el);
    });
    if (!off)
      document.querySelectorAll('[data-parallax]').forEach(function (el) {
        par.add(el);
      });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      par.forEach(function (el) {
        if (!el.isConnected) {
          par.delete(el);
          return;
        }
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var f = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var y = (r.top + r.height / 2 - vh / 2) * -f;
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
    });
  }

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      scan();
      onScroll();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  scan();
  onScroll();
  window.AbbaCoMotion = { scan: scan };
})();
